<div class="p-4">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2 class="m-0">Manual Attendance</h2>
    <!-- <div [innerHTML]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'" class="cursor-pointer" (click)="closeDialog()" (keydown)="closeDialog()" tabindex="0"></div> -->
  </div>

  <!-- Search Bar -->
  <div class="search-container mb-4">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Search Students</mat-label>
      <input matInput [(ngModel)]="searchTerm" (keyup)="applyFilter()" placeholder="Search by name, class or mobile" />
      <mat-icon matSuffix [innerHTML]="SVG_ICONS.SEARCH_ICON() | sanitizer : 'html'"></mat-icon>
    </mat-form-field>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Student List Table -->
  <div *ngIf="!isLoading" class="table-responsive">
    <table mat-table [dataSource]="filteredStudents" class="w-100">
      <!-- Name Column -->
      <ng-container matColumnDef="FirstName">
        <th mat-header-cell *matHeaderCellDef>Student Name</th>
        <td mat-cell *matCellDef="let enrollment" class="align-middle">
          <div class="d-flex align-items-center gap-2">
            <img
            [src]="getStudentProfileImage(enrollment.originalStudent)"
            alt="profile"
            class="profile-img profile-image-container border-radius-50 overflow-hidden d-flex align-items-center justify-content-center bg-white"
            />
            <div>
              <div class="fw-medium">{{ enrollment.studentName }}</div>
              <div class="text-muted small">{{ enrollment.originalStudent.MobileNo }}</div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Center Column -->
      <ng-container matColumnDef="CenterName">
        <th mat-header-cell *matHeaderCellDef>Center Name</th>
        <td mat-cell *matCellDef="let enrollment" class="align-middle">
          <div class="fw-medium">{{ enrollment.centerName }}</div>
          <!-- <div class="text-muted small">{{ enrollment.startTime | date : "shortTime" }} - {{ enrollment.endTime | date : "shortTime" }}</div> -->
        </td>
      </ng-container>

      <!-- Class Column -->
      <ng-container matColumnDef="ClassName">
        <th mat-header-cell *matHeaderCellDef>Class</th>
        <td mat-cell *matCellDef="let enrollment" class="align-middle">
          <div class="fw-medium">{{ enrollment.className }}</div>
          <!-- <div class="text-muted small">{{ enrollment.startTime | date : "shortTime" }} - {{ enrollment.endTime | date : "shortTime" }}</div> -->
        </td>
      </ng-container>

      <!-- Attendance Column -->
      <ng-container matColumnDef="attendance">
        <th mat-header-cell *matHeaderCellDef class="text-center">Attendance</th>
        <td mat-cell *matCellDef="let enrollment" class="text-center align-middle">
          <button mat-button [ngClass]="{ present: enrollment.isPresent, absent: !enrollment.isPresent }" (click)="toggleAttendance(enrollment)" class="attendance-toggle">
            {{ enrollment.isPresent ? "Present" : "Absent" }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-light"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover-row"></tr>
    </table>

    <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons class="mt-3">
    </mat-paginator>
  </div>
  <div align="end" class="mt-5">
    <button class="close-btn me-2 px-4 py-1" style="background-color: black;color: white;" (click)="closeDialog()">Close</button>
  </div>
</div>
